import React from 'react';
import CardMaterial from '@mui/material/Card';
import useBootstrapSize from '../../../hooks/useBootstrapSize';

/**
 *
 * @param {Object} props
 * @param {"elevation" | "outlined"} props.variant
 * @param {boolean} props.alwaysCard
 * @param {import('@mui/material').SxProps} props.sx
 */
export default function Card({ children, alwaysCard = false, variant, sx }) {
  const { isMobile } = useBootstrapSize();
  const isShowCard = !isMobile || alwaysCard;
  return isShowCard ? (
    <CardMaterial variant={variant} sx={sx}>
      {children}
    </CardMaterial>
  ) : (
    <>{children}</>
  );
}
